import type { Libraries } from "@react-google-maps/api";

// Single shared, stable reference for the Google Maps loader `libraries` option.
// @react-google-maps/api reloads the Maps script (and logs a performance
// warning) when useJsApiLoader receives a freshly-created array. All loaders use
// the same `id` ("google-map-script"), so they must pass the SAME array
// reference — import this constant instead of declaring `["places"]` inline.
export const GOOGLE_MAPS_LIBRARIES: Libraries = ["places"];
